import { useContext } from 'react';
import {
  ObjectPendenciesContext,
  ObjectPendenciesContextValue,
} from '../contexts/ObjectPendencies.context';

export const useObjectPendencies = (): ObjectPendenciesContextValue => {
  return useContext(ObjectPendenciesContext);
};
